module.exports = __webpack_public_path__ + "img/stock.59a50a68.svg";